import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/page/Home/index.vue'
import Play from '@/page/Play/index.vue'
import Wrong from '@/page/Wrong/index.vue'
import Finshed from '@/page/Finshed/index.vue'
import CorrectEntry from '@/page/CorrectEntry/index.vue'
import MyRedPacket from '@/page/MyRedPacket/index.vue'
import Share from '@/page/Share/index.vue'

Vue.use(Router)
export default new Router({
  scrollBehavior: function (to, from, savedPosition) {
    return savedPosition || { x: 0, y: 0 }
  },
  routes: [
    {
      path: '/',
      redirect: '/home'
    },
    {
      path: '/home',
      name: 'home',
      component: Home,
      meta: {
        title: '答题拼图的红包',
        needRegister: false,
        pageName: '答题-首页'
      }
    },
    {
      path: '/play',
      name: 'play',
      component: Play,
      meta: {
        title: '答题拼图的红包',
        needRegister: true,
        pageName: '答题-答题页'
      }
    },
    {
      path: '/wrong',
      name: 'wrong',
      component: Wrong,
      meta: {
        title: '答题拼图的红包',
        needRegister: true,
        pageName: '答题-答错页'
      }
    },
    {
      path: '/finshed',
      name: 'finshed',
      component: Finshed,
      meta: {
        title: '答题拼图的红包',
        needRegister: true,
        pageName: '答题-结束页'
      }
    },
    {
      path: '/correct',
      name: 'correct',
      component: CorrectEntry,
      meta: {
        title: '答题拼图的红包',
        needRegister: true,
        pageName: '答题-答对页'
      }
    },
    {
      path: '/myredpacket',
      name: 'myredpacket',
      component: MyRedPacket,
      meta: {
        title: '答题拼图的红包',
        needRegister: false,
        pageName: '答题-我的红包页'
      }
    },
    {
      path: '/share/:redPackId',
      name: 'share',
      component: Share,
      meta: {
        title: '答题拼图的红包',
        needRegister: false,
        pageName: '答题-分享页'
      }
    }
    // {
    //   path: '/courseDetail/:id',
    //   name: 'courseDetail',
    //   component: CourseDetail,
    //   meta: {
    //     title: "课程详情",
    //     newUserEntry: true
    //   }
    // },
    // {
    //   path: '/courseShare/:id',
    //   name: 'courseShare',
    //   component: CourseShare,
    //   meta: {
    //     title: "课程详情",
    //     newUserEntry: true
    //   }
    // },
    // {
    //   path: '/liveDetail/:id',
    //   name: 'liveDetail',
    //   component: LiveDetail,
    //   meta: {
    //     title: "直播详情",
    //     newUserEntry: true
    //   }
    // },
    // {
    //   path: '/liveShare/:id',
    //   name: 'liveShare',
    //   component: LiveShare,
    //   meta: {
    //     title: "直播详情",
    //     newUserEntry: true
    //   }
    // },
    // {
    //   path: '/headlineList',
    //   name: 'headlineList',
    //   component: HeadlineList,
    //   meta: {
    //     title: "头条"
    //   }
    // },
    // {
    //   path: '/headlineShare/:id',
    //   name: 'headLineShare',
    //   component: HeadlineShare,
    //   meta: {
    //     title: "头条"
    //   }
    // },
    // {
    //   path: '/headlineDetail/:id',
    //   name: 'headlineDetail',
    //   component: HeadlineDetail,
    //   meta: {
    //     title: "头条详情",
    //     newUserEntry: true
    //   }
    // },
    // {
    //   path: '/zoneList',
    //   name: 'zoneList',
    //   component: ZoneList,
    //   meta: {
    //     title: "专区"
    //   }
    // },
    // {
    //   path: '/signIn/:id',
    //   name: 'signIn',
    //   component: SignIn,
    //   meta: {
    //     title: "签到",
    //     newUserEntry: true
    //   }
    // },
    // {
    //   path: '/universally/:id',
    //   name: 'universally',
    //   component: Universally,
    //   meta: {
    //     title: "专区详情",
    //     newUserEntry: true
    //   }
    // },
    // {
    //   path: '/facingEachOther',
    //   name: 'facingEachOther',
    //   component: FacingEachOther,
    //   meta: {
    //     title: "超级面对面"
    //   }
    // },
    // {
    //   path: '/liveTrailer',
    //   name: 'liveTrailer',
    //   component: LiveTrailer,
    //   meta: {
    //     title: "直播预告"
    //   }
    // },
    // {
    //   path: '/perfect',
    //   name: 'perfect',
    //   component: Perfect,
    //   meta: {
    //     title: "完善信息",
    //     newUserEntry: true
    //   }
    // }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js